import React from 'react';
import './ChatNoteSystemMessageRow.css';
import IndividualStandardMessageRow from '../timeline/IndividualStandardMessageRow';
import SystemMessageCard from '../timeline/SystemMessageCard';
import { getGroupNotePreviewText } from './groupNoteMessageUtils';
import AdminSenderName from '../timeline/AdminSenderBadge';
import NoteMessagePreview from './NoteMessagePreview';

const NOTE_VERBS = {
  note_create: '作成しました',
  note_update: '修正しました',
  note_delete: '削除しました',
};

const normalizeText = (value) => String(value || '').trim();

const resolveNoteFormat = (message) => normalizeText(message?.message_format).toLowerCase();

const resolveNoteAuthorName = (message, fallbackAuthorName = '') =>
  normalizeText(
    fallbackAuthorName ||
      message?.author_display_name ||
      message?.authorDisplayName ||
      message?.admin_name ||
      message?.admin_full_name ||
      message?.admin_display_name ||
      message?.admin_username ||
      message?.artist_name ||
      message?.artist_name_en ||
      message?.sender_name ||
      ''
  ).replace(/\s*[(（](?:Tacticart|Casticart)[)）]\s*$/i, '');

const buildNotePreviewText = (message, authorName = '') => {
  const format = resolveNoteFormat(message);
  const verb = NOTE_VERBS[format] || '';
  const normalizedAuthorName = normalizeText(authorName);
  if (normalizedAuthorName && verb) return `${normalizedAuthorName}がノートを${verb}。`;
  return getGroupNotePreviewText(message);
};

const ChatNoteSystemMessageRow = ({
  message,
  timeLabel = '',
  onOpenNote,
  activeAnchorMessageId = '',
  anchorClassName = 'is-anchor-hit',
  variant = 'im',
  preset = undefined,
  bubbleClassName = 'system-message',
  avatarNode = null,
  senderName = '',
  senderContent = null,
  showSender = true,
  authorIsAdmin = false,
}) => {
  const noteId = message?.note_id || null;
  const authorName = resolveNoteAuthorName(message, senderName);
  const resolvedSenderContent =
    senderContent || (authorIsAdmin ? <AdminSenderName name={authorName} /> : authorName);
  return (
    <IndividualStandardMessageRow
      message={message}
      variant={variant}
      preset={preset}
      isSelf={false}
      senderName={authorName}
      senderContent={resolvedSenderContent}
      showSender={showSender && Boolean(authorName)}
      readCount={0}
      readLabel=""
      timeLabel={timeLabel}
      avatarNode={avatarNode}
      rowClassName="chat-note-system-row"
      bubbleClassName={`chat-note-system-card-bubble ${bubbleClassName}`.trim()}
      anchorClassName={anchorClassName}
      activeAnchorMessageId={activeAnchorMessageId}
      renderMessageContent={() => (
        <SystemMessageCard title="ノート" showIcon={false} iconClass="fa-note-sticky" className="chat-note-system-card system-message-card--note">
          <div className="system-message-card__text">{buildNotePreviewText(message, authorName)}</div>
          <NoteMessagePreview message={message} />
          {noteId && typeof onOpenNote === 'function' ? (
            <div className="system-message-card__actions">
              <button type="button" className="system-message-card__link" onClick={() => onOpenNote(noteId)}>
                ノートを見る
              </button>
            </div>
          ) : null}
        </SystemMessageCard>
      )}
    />
  );
};

export default ChatNoteSystemMessageRow;
